<template>
  <div>
    <van-nav-bar
      style="background: #ffffff;color:#323233;font-weight: bold"
      fixed
      title="收发存查询"
      left-arrow
      @click-left="onClickLeft"
    />
    <div id="aaa"></div>
    <van-cell-group title="选择影像中心" :border="false" style="margin-left: 10px;">
      <van-cell
        icon="location-o"
        :title="currentAgent.name"
        is-link
        @click="toPwalist"
        style="border-bottom:0.1px solid 	#F5F5F5"
      >
      <!-- <template #extra>
        <span class="custom-title">单元格</span>
        <van-datetime-picker
            v-model="currentDate"
            title="选择年月"
            type="year-month"
            @confirm="confirmDate"
            @cancel="cancelDate"
          />
        
      </template> -->
      </van-cell>
    </van-cell-group>
    <van-cell-group  :border="false" style="margin-left: 10px;">
      <van-cell style="border-bottom:0.1px solid 	#F5F5F5">
        <van-dropdown-menu>
          <van-dropdown-item :title="date" ref="item">
            <van-datetime-picker
              v-model="currentDate"
              title="选择年月"
              type="year-month"
              @confirm="confirmDate"
              @cancel="cancelDate"
            />
          </van-dropdown-item>
        </van-dropdown-menu>
      </van-cell>
    </van-cell-group>
    <van-cell-group  :border="false" style="margin-left: 10px;">
      <van-cell style="border-bottom:0.1px solid 	#F5F5F5">
          <van-search 
            v-model="keyword" 
            shape="round" 
            show-action
            placeholder="请输入搜索关键词"
            @search="onSearch"
            @cancel="onCancel" 
          />
      </van-cell>
    </van-cell-group>
    <van-cell-group title="收发存明细" :border="false" v-if="record[0]">
      <van-cell
        v-for="(item,index) in record"
        :key="index"
        :class="{discolor:index%2==0}"
      >
        <van-row type="flex">
          <van-col span="3">型号:</van-col>
          <van-col span="19">{{ item.modelname }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between">
          <van-col span="3">类别:</van-col>
          <van-col span="8">{{ item.first_category_name }}</van-col>
          <van-col span="3">品牌:</van-col>
          <van-col span="8">{{ item.brand_name }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between">
          <van-col span="5">上月结存:</van-col>
          <van-col span="6">{{ item.carryOverOfLastMonth }}</van-col>
          <van-col span="5">本月入库:</van-col>
          <van-col span="6">{{ item.warehouseInThisMonth }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between">
          <van-col span="5">本月结存:</van-col>
          <van-col span="6">{{ item.balanceOfThisMonth }}</van-col>
          <van-col span="5">本月出库:</van-col>
          <van-col span="6">{{ item.stockOutThisMonth }}</van-col>
        </van-row> 
      </van-cell>
    </van-cell-group>
    <!-- <van-empty v-else description="暂无结果" /> -->
    
    
  </div>
</template>
<script>
import {
  NavBar,
  DropdownMenu,
  DropdownItem,
  Col,
  Row,
  DatetimePicker,
  Search,
  Empty,
} from "vant";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Col.name]: Col,
    [Row.name]: Row,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [DatetimePicker.name]: DatetimePicker,
    [Search.name]: Search,
    [Empty.name]: Empty,
  },
  data() {
    return {
      currentDate: new Date(),
      //当前选中的影像中心
      currentAgent: "",
      date:'',
      keyword:'',
      record:[],
    };
  },

  methods: {
    ...mapMutations(["changePermissionAgent", "changeDefaultAgentIndex"]),
    onClickLeft() {
      this.$router.push("index");
    },
    toPwalist() {
      this.$router.push("/pwalist");
    },
    onSearch(val) {
      this.handleAjax(this, this.currentAgent.erp_code, this.date, val);
    },
    onCancel() {
      this.handleAjax(this, this.currentAgent.erp_code, this.date, this.keyword);
    },
    confirmDate() {
      this.$refs.item.toggle();
      this.date = this.parseDate(this.currentDate);
      this.handleAjax(this, this.currentAgent.erp_code, this.date, this.keyword);
    },
    cancelDate() {
      this.$refs.item.toggle();
      this.date = '选择年月';
      let defaultMonth = this.parseDate(new Date());
      this.handleAjax(this, this.currentAgent.erp_code, defaultMonth, this.keyword);
    },
    parseDate(obj) {
      let year = obj.getFullYear();
      let month = obj.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      return year + "-" + month;
    },
    handleAjax(instance,erp,date,modelname) {
      instance.$http
        .post("/mobile/operateStockChangeRecord", {
          projectErpCode: erp,
          date: date,
          modelname: modelname
        })
        .then(function (response) {
          instance.record = response.stockData;
        });
    },
  },
  computed: {
    ...mapState(["permissionAgent", "defaultAgentIndex"]),
  },

  created() {
    if (this.permissionAgent) {
      let _this = this;
      this.currentAgent = this.permissionAgent.find(function (item) {
        return item.id == _this.defaultAgentIndex;
      });
      this.date = this.parseDate(this.currentDate);
      this.handleAjax(_this,this.currentAgent.erp_code,this.date,this.keyword);
    } else {
      let _this = this;
      this.$http
        .post("/mobile/rimsAgentList", {
          username: localStorage.getItem("usermobile"),
        })
        .then(function (response) {
          if (response) {
            _this.changePermissionAgent(response.rimsAgent);
            _this.changeDefaultAgentIndex(response.rimsAgent[0].id);
            _this.currentAgent = _this.permissionAgent.find(function (item) {
              return item.id == _this.defaultAgentIndex;
            });
            _this.date = _this.parseDate(_this.currentDate);
            _this.handleAjax(_this,_this.currentAgent.erp_code,_this.date,_this.keyword);
          }
        });
    }
  },
};
</script>
<style scoped lang="less">
#aaa {
  width: 100vw;
  height: 46px;
}
.van-cell-group__title {
  color: #323233 !important;
  font-weight: bold;
  font-size: 0.38rem;
  background-color: #f7f8fa;
}
.van-cell {
  color: #969799 !important;
}
.discolor {
  background-color: #F5F5F5;
}
</style>